import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store/index.js';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/groups/',
    name: 'Groups',
    meta: { auth: true, secure: true },
    component: () => import('../views/Groups.vue'),
  },
  {
    // path: '/merch/:id',
    path: '/merch',
    name: 'Merchandise',
    component: () => import('../views/Merchandise.vue'),
  },
  {
    path: '/order',
    name: 'Order',
    component: () => import('../views/Order.vue'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
  },
  {
    path: '/law',
    name: 'Law',
    component: () => import('../views/Law.vue'),
  },
  {
    path: '/policy',
    name: 'Policy',
    component: () => import('../views/Policy.vue'),
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => import('../views/Terms.vue'),
  },
  {
    path: '/auth',
    meta: { auth: true },
    name: 'MyAccount',
    component: () => import('../views/MyAccount.vue'),
  },
  {
    path: '/verify/email/:token',
    name: 'VerifyEmail',
    component: () => import('../views/VerifyEmail.vue'),
  },
  {
    path: '/verify/group/:token',
    name: 'VerifyGroup',
    component: () => import('../views/VerifyGroup.vue'),
  },
  {
    path: '/reset/password/:token',
    name: 'ResetPassword',
    component: () => import('../views/ResetPassword.vue'),
  },
  {
    path: '/maintenance',
    name: 'MasterMaintenance',
    meta: { auth: true, secure: true, secret: true },
    component: () => import('../views/MasterMaintenance.vue'),
  },
  {
    path: '/notice',
    name: 'NoticeMaintenance',
    meta: { auth: true, secure: true, secret: true },
    component: () => import('../views/NoticeMaintenance.vue'),
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(function(to, _, next) {
  if (to.meta.auth) {
    if (!store.getters['auth/authUser']) {
      next('/');
    }

    if (to.meta.secure) {
      if (
        store.getters['auth/authUser'] &&
        store.getters['auth/authUser'].authority != 1
      ) {
        next('/');
      }
    }
    if (to.meta.secret) {
      if (
        store.getters['auth/authUser'] &&
        store.getters['auth/authUser'].authority != 1 &&
        store.getters['auth/authUser'].id != 1
      ) {
        next('/');
      }
    }
  }
  next();
});
export default router;
